import { DialogRef } from '@angular/cdk/dialog';
import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';
import { Chart, ChartConfiguration } from 'chart.js';


@Component({
  selector: 'mnf-graph-dom',
  templateUrl: './graph-dom.component.html',
  styleUrls: ['./graph-dom.component.scss']
})
export class GraphDomComponent implements AfterViewInit {

  @Output() planSelectedEvent = new EventEmitter<any>();

  amount: string;

  selectedPlan: any = null;

  // Planes a mostrar 
  plans = [
    { totalMonths: 60, benefit: 3000, text: '60 meses', percent: 3.00 },
    { totalMonths: 48, benefit: 2000, text: '48 meses', percent: 2.00 },
    { totalMonths: 36, benefit: 1200, text: '36 meses', percent: 1.20 },
    { totalMonths: 24, benefit: 600, text: '24 meses', percent: 0.60},
    { totalMonths: 18, benefit: 300, text: '18 meses', percent: 0.30 },
    { totalMonths: 12, benefit: 150, text: '12 meses', percent: 0.15 },
    { totalMonths: 6, benefit: 50, text: '6 meses', percent: 0.05 },
  ]

  /** Variables para cambiar la información del plan */
  // Saldo promedio
  balanceAverage: number = 0;
  // Monto ingresado
  amountInit: number = 0
  // Total invertido
  totalInvert: number = 0;
  // Plusvalia estimada
  plusvaliaEstimate: number = 0;
  // Rendimiento estimado
  peformanceEstimate: number = 0;
  // Bonificación esperada
  benefitEstimate: number = 0;
  // Total ganancias
  totalProfits: number = 0;

  // Gráfica de plan esperado
  myChart: any;

  constructor(private dialogRef: DialogRef<any>) { }
  
  ngOnInit(): void {
    // Inicializar monto inicial de forma automatica
    this.amountInit = (Number(this.amount));

    // Actuliazr la bonificación esperada dependiendo del monto inicial
    this.updateBenefits(this.amountInit);
  
    // Inicializar el monto total ganado parcial (Se actualiza en cuanto seleccione un plan)
    this.totalProfits = this.amountInit;

  }

  ngAfterViewInit() {
    this.createChartPerformance();
  }

  /** Hacer color gradiantes dependiendo del plan seleccionado */
  getColor(item: any) {
    let opacity = item.totalMonths / 60; 
    return `rgba(19, 97, 118, ${opacity})`
  }

  // Plan a seleccionar
  selectPlan(plan: any) {
    this.selectedPlan = plan;
    // Actualiza el total invertido
    if (this.amount && this.selectedPlan) {
      // Monto inicial
      this.amountInit = (Number(this.amount) * this.selectedPlan.totalMonths);

      // Calcular el monto ingreasdo: Monto ingresado * plan seleccionado sumando 1000 de un mes más
      this.totalInvert = (Number(this.amount) * (this.selectedPlan.totalMonths + 1)); 

      // Calcular el saldo promedio: Monto ingresado dividido entre 2
      this.balanceAverage = this.totalInvert / 2;

      // Calcular plusvalia: 0.00334 * meses del plan seleccionado
      const plusvaliaPerMonth = 0.00334 * this.selectedPlan.totalMonths;
      // Calcular plusvalia estimada: plusvalia * saldo promedio
      this.plusvaliaEstimate = (plusvaliaPerMonth * this.balanceAverage);

      // Calcular rendimiento esperado
      const peformancePerMonth = this.balanceAverage * Math.pow(1 + 0.01, this.selectedPlan.totalMonths);
      this.peformanceEstimate = (peformancePerMonth - this.balanceAverage);

      // Asignar bonificación esperada por meses seleccionados
      this.benefitEstimate = (this.selectedPlan.benefit);

      // Total a ganar del monto inicial a los meses seleccionados
      this.totalProfits = (this.amountInit + this.peformanceEstimate + this.plusvaliaEstimate + this.benefitEstimate);      
    }
  }

  /** Actualizar las bonificaciones esperadas dependiendo del monto inicial */
  updateBenefits(amount: number): void {
    this.plans.forEach(plan => {
      plan.benefit = amount * plan.percent;
    });
  }

  // Crear gráfica de plan esperado
  createChartPerformance(): void {
    const labels = this.plans.map(plan => plan.text);
    const dataInfo = this.plans.map(plan => plan.percent * 100);

    const data = {
      labels: labels,
      datasets: [
        {
          label: 'Bonificación esperada',
          data: dataInfo,
          backgroundColor: [
            '#136176',
          ],
          hoverOffset: 4,
          borderSkipped: false,
          borderColor: '#fff',
          borderWidth: 2,
          borderRadius: {
            topLeft: 8,
            topRight: 8,
            bottomLeft: 0,
            bottomRight: 0
          }
      },
    ]
    };

    let delayed;

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        title: {
          display: true,
        },
      },
      animation: {
        onComplete: () => {
          delayed = true;
        },
        delay: (context) => {
          let delay = 0;
          if (context.type === 'data' && context.mode === 'default' && !delayed) {
            delay = context.dataIndex * 300 + context.datasetIndex * 100;
          }
          return delay;
        },
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          stacked: true,
        },
        y: {
          grid: {
            display: false
          },
          ticks: {
            callback: function(value, index, values) {
              return value + '%';
            }
          },
          stacked: true
        }
      }
    }

    const config: ChartConfiguration = {
      type: 'bar',
      data: data,
      options: options
    };

    const myChart = new Chart(document.getElementById('myChart') as any, config);
  }

  /** Mandar información al componente padre */
  sendInfoPlanSelected() {

    // Enviar arreglo con información ya definida
    const data = {
      plan: this.selectedPlan,
      amountInit: this.amountInit,
      peformanceEstimate: this.peformanceEstimate,
      plusvaliaEstimate: this.plusvaliaEstimate,
      benefitEstimate: this.benefitEstimate,
      totalProfits: this.totalProfits
    };

    
    // Enviar informacíon del plan seleccionado
    this.planSelectedEvent.emit(data);

    // Cerrar modal
    this.dialogRef.close();

  }

}
